import styled from "styled-components"
import Breakpoints from "../shared/breakpoints"
import {
  desktopTextStyles,
  mobileTextStyles,
  tabletTextStyles,
} from "../shared/typography.styles"

export const StatItem = styled.li`
  display: flex;
  align-items: end;
  padding: 16px 0 0 5vw;
  text-align: left;

  :nth-child(2) {
    padding: 16px 5vw 0 0;
    align-self: flex-end;
  }

  @media (min-width: ${Breakpoints.md}) {
    flex-direction: column;
    padding: 8px 0 0 0;
    text-align: center;
    align-items: center;
    :nth-child(2) {
      padding: 8px 0 0 0;
      align-self: unset;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
    align-items: flex-start;
  }
`

export const StatRow = styled.ul`
  display: flex;
  flex-direction: column;
  align-self: flex-start;

  @media (min-width: ${Breakpoints.md}) {
    & > ${StatItem}:not(:last-child) {
      padding-right: 48px;
    }
    align-self: center;

    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    justify-content: flex-start;
    align-self: flex-start;
    & > ${StatItem}:not(:last-child) {
      padding-right: 32px;
    }
  }
`

export const StatItemNumber = styled.span`
  ${mobileTextStyles.MobileHeadingTwoRegular}
  letter-spacing: 0;
  & > span {
    line-height: 0px;
  }
  & > .short {
    // will only display on sm/md screens
    display: inline;
  }
  & > div {
    //will only display on lg screens
    display: none;
  }

  padding-right: 12px;
  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingTwoSemiBold}
    letter-spacing: 0;

    & > span {
      font-size: 16px;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeRegular}
    letter-spacing: 0;

    & > span {
      font-size: 18px;
    }
    & > .short {
      display: none;
    }
    & > div {
      display: inline;
    }
  }
`

export const StatItemDescription = styled.span`
  ${desktopTextStyles.LinkText}
  line-height: 140%;
  opacity: 0.5;
  letter-spacing: 0.05em;
  & > span {
    display: block;
  }

  padding-bottom: 4px; // align with StatItemNumber
  @media (min-width: ${Breakpoints.md}) {
    padding-bottom: 0px; // reset
  }
  @media (min-width: ${Breakpoints.lg}) {
    & > span {
      display: inline;
    }
  }
`
